//colorcode.js
import theme from '../assests/theme'
export const CC_RULES_ELECTIVE_BG = theme.palette.primary.lightest;
export const CC_RULES_GREYCELLS_BG = theme.palette.grey.lightest;
export const CC_RULES_ROWHEADERS_BG = theme.palette.grey.lighter;
export const CC_RULES_COLUMNHEADERS_BG = theme.palette.grey.lighter;
export const CC_RULES_TOTALPRD_HEAD_BG = theme.palette.orange;
export const CC_RULES_TOTALPRD_ROW_BG = "#ffe0bf";
export const CC_RULES_TOTALPRD_BORDER = theme.palette.orange;
export const CC_RULES_GRID_BORDER = theme.palette.grey.main;
